import { render, staticRenderFns } from "./UseCase.vue?vue&type=template&id=fb960666&scoped=true&"
import script from "./UseCase.vue?vue&type=script&lang=js&"
export * from "./UseCase.vue?vue&type=script&lang=js&"
import style0 from "./UseCase.vue?vue&type=style&index=0&id=fb960666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb960666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VChip})
